import React from 'react';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import ProfilePersonalInfoEdit from 'apps/auth/components/profile/ProfilePersonalInfoEdit';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE_FIELDS } from 'apps/auth/constants/UrlConstants';

const ProfileAddPersonalInfoPage = () => {
    return (
        <CommonPage backUrl={AUTH_PROFILE_FIELDS} leftCloseIcon hasBottomPanel showChat={false}>
            <ProfilePersonalInfoEdit />
        </CommonPage>
    );
};

export default BasePage(ProfileAddPersonalInfoPage);
